import type { User } from '@/core/auth/types';
import { canManagePayrollModule } from '@/core/auth/modulePermissions';

export function canViewCompensation(
  user: User | null | undefined,
  locationId?: string | null,
): boolean {
  return canManagePayrollModule(user, locationId);
}

export function canManagePayroll(
  user: User | null | undefined,
  locationId?: string | null,
): boolean {
  return canManagePayrollModule(user, locationId);
}
